import { render, staticRenderFns } from "./SocialReportingCell.vue?vue&type=template&id=7ec5a86e&scoped=true&"
import script from "./SocialReportingCell.vue?vue&type=script&lang=js&"
export * from "./SocialReportingCell.vue?vue&type=script&lang=js&"
import style0 from "./SocialReportingCell.vue?vue&type=style&index=0&id=7ec5a86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec5a86e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VImg,VTooltip})
